const isMember = user => {
	if (user) {
		if (user.claims) {
			return user.claims.member;
		}
	}
	return false
};

export default isMember;